import styled from '@emotion/styled'
import { memo } from 'react'
import { palette } from '../styles/colors'

const ImgRoot = styled('img')({
    flex: '0 1 auto',
    maxWidth: 100,
    padding: 2,
    filter: palette.imagesMonochromeFilter,
})

const ShareIcon = memo(() => <ImgRoot src="/static/logos/mfcs-green-h.png" />)

export default ShareIcon
